import contract from './capabilities.json';
export const workflowPolicyVersion = contract.policyVersion;
export const roleLabels = contract.roles;
export const normalizedRoles = user => [...new Set((user?.roles || (user?.role ? [user.role] : [])).map(role => role.replace(/^ROLE_/, '')))];
export const canPerform = (user, action) => normalizedRoles(user).some(role => (contract.actions[action] || []).includes(role));
export const capabilitiesFor = user => Object.keys(contract.actions).filter(action => canPerform(user, action));
